import { useEffect, useState } from "react";

export interface FtmResourceState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function useFtmResource<T>(loader: () => Promise<T>): FtmResourceState<T> {
  const [state, setState] = useState<FtmResourceState<T>>({ data: null, loading: true, error: null });

  useEffect(() => {
    let active = true;
    setState({ data: null, loading: true, error: null });
    loader()
      .then((data) => { if (active) setState({ data, loading: false, error: null }); })
      .catch((error: unknown) => {
        if (!active) return;
        setState({ data: null, loading: false, error: error instanceof Error && error.message ? error.message : "The public report data could not be loaded." });
      });
    return () => { active = false; };
  }, [loader]);

  return state;
}
